import apiClient from '../apiClient';
import { GET_TRANSPORTATION_UNIT_ALL_URL } from '../apiUrl';

const getTransportationUnitAll = () => {
  return apiClient.get(GET_TRANSPORTATION_UNIT_ALL_URL);
};

export default getTransportationUnitAll;
